export default __webpack_public_path__ + "static/media/goods14.a59f02c6.png";